var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friend"},[_c('el-card',{staticClass:"box-card "},[_c('el-avatar',{staticStyle:{"max-width":"100%"},attrs:{"shape":"square","size":230,"fit":_vm.fit,"src":require("../assets/images/avatar.jpg")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }